import moment from "moment";

export const formatDateTime = (date, includeTime = false) => {
    if (!date) return "-";

    const dateTime = moment(date);

    if (!dateTime.isValid()) return "-";

    const formattedDate = dateTime.format("MMM DD YYYY");

    // Include Time (12-hour format with am/pm)
    if (includeTime) {
        const formattedTime = dateTime.format("h:mm a");
        return `${formattedDate} ${formattedTime}`;
    }

    return formattedDate;
};
